// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen3/styles.scss
// module id = 386
// module chunks = 0